import { Vue, Component, Ref, Prop, Emit, Provide } from 'vue-property-decorator'
import { Nullable } from '@/shared/types/app.types'
import {
    ConfigurationIncidentsSeveritiesLaboratoriesCreateRequest,
    ConfigurationIncidentsSeveritiesLaboratoriesPatchInBatchRequest,
    ConfigurationIncidentsSeveritiesLaboratoriesResponse
} from '@/modules/configurationModule/detail/incidents/incidents-severities/services/incidents-severities-laboratories.dto'
import {
    ConfigurationIncidentsSeveritiesModalState,
    initialConfigurationIncidentsSeveritiesModalState
} from '@/modules/configurationModule/detail/incidents/incidents-severities/components/incidents-severities-modal/incidents-severities-modal.model'
import { IncidentSeverityResponse } from '@/modules/configurationModule/detail/incidents/incidents-severities/services/incidents-severities.dto'
import { incidentsSeveritiesConfigurationServices } from '@/modules/configurationModule/detail/incidents/incidents-severities/services/incidents-severities.service'
import { BModal } from 'bootstrap-vue'

@Component
export default class IncidentsSeveritiesModal extends Vue {
    @Ref() readonly incidentSeveritiesModal!: BModal
    @Prop(Boolean) readonly isGlobal!: boolean
    @Provide() externalValidator = this.$validator
    @Emit()
    update(): ConfigurationIncidentsSeveritiesLaboratoriesPatchInBatchRequest[] {
        return [{
            active: this.state.active,
            daysToClosingDelay: this.state.daysToClosingDelay,
            mandatoryNotification: this.state.mandatoryNotification,
            id: this.state.id
        }]
    }
    @Emit()
    create(): ConfigurationIncidentsSeveritiesLaboratoriesCreateRequest {
        return {
            active: this.state.active,
            daysToClosingDelay: this.state.daysToClosingDelay,
            mandatoryNotification: this.state.mandatoryNotification,
            incidentSeverityId: this.state.incidentSeverity?.id
        }
    }
    state: ConfigurationIncidentsSeveritiesModalState

    get laboratoryId(): number {
        return this.$store.getters.labId
    }

    get actionTitle(): string {
        return this.state.id ? this.$t('configuration.actions.update').toString()
            : this.$t('configuration.actions.add').toString()
    }

    get disabledIncidentSeveritiesCombo(): boolean {
        return !!this.state.id
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    constructor() {
        super()
        this.state = initialConfigurationIncidentsSeveritiesModalState()
    }

    async show(selectedRow: Nullable<ConfigurationIncidentsSeveritiesLaboratoriesResponse>): Promise<void> {
        await this.initializeIncidentSeverity(selectedRow)
        this._showModal()
    }

    private _showModal(): void {
        this.incidentSeveritiesModal.show()
    }

    async initializeIncidentSeverity(incidentSeverity: Nullable<ConfigurationIncidentsSeveritiesLaboratoriesResponse>): Promise<void> {
        this.state = initialConfigurationIncidentsSeveritiesModalState()
        await this.$validator.reset()
        if (incidentSeverity) {
            this.state = {
                id: incidentSeverity.id,
                active: incidentSeverity.active,
                mandatoryNotification: incidentSeverity.mandatoryNotification,
                incidentSeverity: incidentSeverity.incidentSeverity,
                daysToClosingDelay: incidentSeverity.daysToClosingDelay
            }
        }
    }

    async getAllIncidentSeverities(): Promise<IncidentSeverityResponse[] | void> {
        const params = {}
        const [err, data] = await this.$_toCall(incidentsSeveritiesConfigurationServices.paginator({}, params), true)
        if (err) {
            return
        }
        return data.content
    }

    actionModal(): void {
        if (this.state.id) {
            this.update()
        } else {
            this.create()
        }
    }

    hide(): void {
        this.incidentSeveritiesModal.hide()
    }
}
